module.exports = __webpack_public_path__ + "static/media/Rima.86fb7280.jpg";